import { b as p, i as h } from "./_arrayPush-DUvcoEi5.mjs";
import { i as d } from "./isSymbol-BlvQGt6F.mjs";
var o = p(), y = "Expected a function";
function c(r, e) {
  if (typeof r != "function" || e != null && typeof e != "function")
    throw new TypeError(y);
  var t = function() {
    var a = arguments, n = e ? e.apply(this, a) : a[0], i = t.cache;
    if (i.has(n))
      return i.get(n);
    var s = r.apply(this, a);
    return t.cache = i.set(n, s) || i, s;
  };
  return t.cache = new (c.Cache || o)(), t;
}
c.Cache = o;
var j = c, b = /\s/;
function _(r) {
  for (var e = r.length; e-- && b.test(r.charAt(e)); )
    ;
  return e;
}
var u = _, x = u, I = /^\s+/;
function E(r) {
  return r && r.slice(0, x(r) + 1).replace(I, "");
}
var T = E, O = T, m = h, C = d, f = NaN, N = /^[-+]0x[0-9a-f]+$/i, $ = /^0b[01]+$/i, w = /^0o[0-7]+$/i, z = parseInt;
function B(r) {
  if (typeof r == "number")
    return r;
  if (C(r))
    return f;
  if (m(r)) {
    var e = typeof r.valueOf == "function" ? r.valueOf() : r;
    r = m(e) ? e + "" : e;
  }
  if (typeof r != "string")
    return r === 0 ? r : +r;
  r = O(r);
  var t = $.test(r);
  return t || w.test(r) ? z(r.slice(2), t ? 2 : 8) : N.test(r) ? f : +r;
}
var v = B;
export {
  T as _,
  j as m,
  v as t
};
//# sourceMappingURL=toNumber-CC053IJe.mjs.map
